// VFX: Countdown Timer Ring
// Category: intros-outros · Tags: cta, countdown, timer, urgency, ring
// Timer com anel SVG se esvaziando + número contando regressivamente.
import { AbsoluteFill, useCurrentFrame, useVideoConfig } from "remotion";
import React from "react";

export interface CountdownRingProps {
  seconds?: number;
  label?: string;
  accentColor?: string;
}

export default function CountdownRing({ seconds = 10, label = "Restam", accentColor = "#ef4444" }: CountdownRingProps) {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const progress = frame / durationInFrames;
  const remaining = Math.max(0, Math.ceil(seconds * (1 - progress)));
  const r = 80;
  const circ = 2 * Math.PI * r;
  const dashoffset = circ * progress;
  return (
    <AbsoluteFill style={{ alignItems: "center", justifyContent: "center", background: "#0a0e1a" }}>
      <div style={{ position: "relative", width: 240, height: 240 }}>
        <svg viewBox="0 0 200 200" style={{ position: "absolute", inset: 0, transform: "rotate(-90deg)", width: 240, height: 240 }}>
          <circle cx="100" cy="100" r={r} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" />
          <circle cx="100" cy="100" r={r} fill="none" stroke={accentColor} strokeWidth="8" strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={dashoffset} style={{ filter: `drop-shadow(0 0 12px ${accentColor}aa)` }} />
        </svg>
        <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: 96, fontWeight: 900, color: "#f8fafc", lineHeight: 1, fontFamily: "system-ui" }}>{remaining}</span>
          <span style={{ fontSize: 16, color: "#94a3b8", marginTop: 8, letterSpacing: 2, textTransform: "uppercase" }}>{label}</span>
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
